// @core/api/endpoints/document/get_block_children.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetBlockChildrenResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Get block children
 * Returns the direct children of a specific block, ordered by position. Used for lazy loading nested content in toggles, columns, etc.
 */
export async function GetBlockChildren(
  document_id: string,
  block_id: string,
  options?: RequestOptions
): Promise<GetBlockChildrenResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:document_id/blocks/:block_id/children`;
  requestPath = requestPath.replace(':document_id', encodeURIComponent(document_id));
  requestPath = requestPath.replace(':block_id', encodeURIComponent(block_id));
  const requestOptions = options;
  return client.get<GetBlockChildrenResponse>(requestPath, { ...requestOptions });
}
